import baby from './icons/colorful-icons/baby.svg';
import hospital from './icons/colorful-icons/hospital.svg';
import babyBottle from './icons/colorful-icons/baby-bottle.svg';
import waterBottle from './icons/colorful-icons/water-bottle.svg';
import salineSolution from './icons/saline-solution.svg';
import tea from './icons/colorful-icons/tea.svg';
import care from './icons/colorful-icons/care.svg';
import nappies from './icons/colorful-icons/nappies.svg';
import toilet from './icons/colorful-icons/toilet.svg';
import child from './icons/colorful-icons/child.svg';
import driving from './icons/driving.svg';
import safe from './icons/colorful-icons/safe.svg';
import virus from './icons/colorful-icons/virus.svg';
import ambulance from './icons/colorful-icons/ambulance.svg';

export default {
  waterBottle,
  babyBottle,
  salineSolution,
  tea,
  care,
  nappies,
  toilet,
  baby,
  child,
  hospital,
  driving,
  safe,
  virus,
  ambulance,
};
